import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { goBack } from "react-router-redux";
import { ProjectActionCreators, AppActionCreators } from "../../../actions";
import { ProjectType } from "../../../utils/enums";
import { RouteUrls } from "../../../configs/routeUrls";
import { PreviewOneFormProjectCard } from "../Project/PreviewOneFormProjectCard";

class BudgetCardPreviewContainerBO extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    let { id, clientId } = this.props.match.params;
    if (id) {
      this.props.getProject(id, clientId);
    }
    this.props.setBreadcrumbs([
      {
        url: RouteUrls.Budget.list.actual,
        displayName: "Budżet obywatelski",
      },
      {
        url: RouteUrls.Budget.vote.previewFunc(id),
        displayName: "Głosowanie",
      },
    ]);
  }

  render() {
    const {
      isAuth,
      isProjectLoading,
      isOnlyOneOffice,
      loggedUserId,
      opinionExecuting,
      voteExecuting,
    } = this.props;

    return (
      <PreviewOneFormProjectCard
        {...this.props.project}
        consultationTitle="Budżet"
        type={ProjectType.PublicBudget}
        disabled={true}
        isAuth={isAuth}
        isProjectLoading={isProjectLoading}
        isOnlyOneOffice={isOnlyOneOffice}
        loggedUserId={loggedUserId != null ? loggedUserId : 0}
        opinionExecuting={opinionExecuting}
        voteExecuting={voteExecuting}
        saveAnswers={(values) => this.props.saveAnswers(values)}
        onCancel={this.props.goBack}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    isAuth: state.app.isAuth,
    isProjectLoading: state.project.isProjectLoading,
    isOnlyOneOffice: state.app.offices && state.app.offices.length === 1,
    opinionExecuting: state.project.opinionExecuting,
    voteExecuting: state.project.voteExecuting,
    project: state.project.project,
    loggedUserId: state.app.loggedUser.userId,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    ...bindActionCreators(
      { ...ProjectActionCreators, ...AppActionCreators },
      dispatch
    ),
    goBack: () => dispatch(goBack()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BudgetCardPreviewContainerBO);
